export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const EBO_PHONE_NUMBER = 9046727027;
